{
  "facebook_ad": {
    "product": {
      "facebook_headline": ["creative", "personalized", "guided"],
      "facebook_primary_text": ["creative", "aida", "list", "pas", "personalized", "guided"]
    },
    "content": {
      "facebook_headline": ["standard", "personalized"],
      "facebook_primary_text": ["standard", "creative", "quotes", "personalized"]
    }
  },
  "google_ad": {
    "product": {
      "google_headline": ["creative"],
      "google_description": ["creative", "personalized", "guided"]
    }
  },
  "taboola_ad": {
    "product": {
      "taboola_headline": ["standard", "creative", "guided"]
    },
    "content": {
      "taboola_headline": ["standard", "creative", "personalized"]
    }
  },
  "outbrain_ad": {
    "product": {
      "outbrain_headline": ["standard", "creative", "guided"]
    },
    "content": {
      "outbrain_headline": ["standard", "creative", "personalized"]
    }
  },
  "linkedin_ad": {
    "product": {
      "linkedin_text_ad_headline": ["creative", "personalized"],
      "linkedin_text_ad_description": ["creative", "personalized", "guided"]
    },
    "content": {
      "linkedin_title": ["creative", "personalized"],
      "linkedin_intro_copy": ["creative", "personalized"]
    }
  },
  "twitter_ad": {
    "product": {
      "twitter_title": ["creative", "personalized", "guided"],
      "twitter_copy": ["creative", "aida", "pas", "personalized", "guided"]
    },
    "content": {
      "twitter_copy": ["creative", "personalized"]
    }
  },
  "pinterest_ad": {
    "product": {
      "pinterest_title": ["creative", "personalized", "guided"],
      "pinterest_description": ["creative", "personalized", "guided"]
    },
    "content": {
      "pinterest_title": ["creative", "personalized"],
      "pinterest_description": ["creative", "personalized"]
    }
  },

  "teads_single_image": {
    "teads_single_image_headline": ["creative", "personalized"],
    "teads_single_image_description": ["creative", "personalized"]
  },
  "teads_single_video": {
    "teads_single_video_headline": ["creative", "personalized"],
    "teads_single_video_description": ["creative", "personalized"]
  },
  "teads_carousel": {
    "teads_carousel_headline": ["creative", "personalized"]
  },
  "teads_social_layout_1": {
    "teads_social_layout_1_headline": ["creative", "personalized"],
    "teads_social_layout_1_primary_text": ["creative", "personalized"],
    "teads_social_layout_1_description": ["creative", "personalized"]
  },
  "teads_social_layout_2": {
    "teads_social_layout_2_primary_text": ["creative", "personalized"]
  },

  "product_landing_page_url": {
    "landing_page_product_name": ["creative"],
    "landing_page_product_description": ["paragraph", "list", "pas", "personalized", "creative"],
    "landing_page_copy": ["default", "rewrite"],
    "landing_page_call_to_action": ["default", "rewrite"],
    "landing_page_headline": ["default", "personalized", "rewrite"]
  },

  "wtm_home_page": {
    "landing_page_product_name": ["creative"],
    "landing_page_product_description": ["paragraph", "list", "pas", "personalized", "creative"],
    "landing_page_copy": ["default", "rewrite"],
    "landing_page_call_to_action": ["default", "rewrite"],
    "landing_page_headline": ["default", "personalized", "rewrite"]
  },
  "features_to_benefits": {
    "consumer_benefits": ["default", "emotional_benefits"]
  },
  "seo_meta_description": {
    "landing_page_seo_meta_data": ["creative"]
  },

  "product_description": {
    "landing_page_product_description": ["paragraph", "list", "pas", "rewrite", "personalized"],
    "landing_page_call_to_action": [],
    "landing_page_product_name": [],
    "landing_page_headline": []
  },
  "amazon_product_description": {
    "amazon_product_description": ["default", "guided"],
    "amazon_feature_list": ["default"]
  },

  "walmart_product_listing": {
    "walmart_product_description": ["default", "guided"],
    "walmart_feature_list": ["default"]
  },

  "landing_page_builder": {
    "landing_page_builder_headline": ["standard", "guided"],
    "landing_page_builder_headline_supporting_copy": ["standard", "guided"],
    "landing_page_builder_cta": ["standard"],
    "landing_page_builder_sub_heading": ["standard", "guided"],
    "landing_page_builder_sub_headline_supporting_copy": ["standard", "guided"],
    "landing_page_builder_benefits": ["list"],
    "landing_page_builder_features": ["list"]
  },

  "facebook_social": {
    "facebook_post": ["creative", "personalized"]
  },
  "instagram_social": {
    "instagram_caption": ["creative", "personalized"]
  },
  "twitter_social": {
    "tweet": ["creative", "personalized"]
  },
  "linkedin_social": {
    "linkedin_post": ["creative", "personalized"]
  },
  "pinterest_social": {
    "pinterest_post_title": ["creative", "personalized"],
    "pinterest_post": ["creative", "personalized"]
  },
  "youtube_social": {
    "youtube_title": ["creative", "personalized"],
    "youtube_description": ["creative", "personalized"]
  },

  "blog_post_builder": {
    "blog_post_outline": [],
    "blog_post_intro_paragraph": [],
    "blog_post_title": [],
    "blog_post_content": []
  },

  "email_subject_line": {
    "email_subject_line": ["standard"]
  },

  "email_promotional": {
    "email_promotional_subject_line": ["engaging"],
    "email_promotional_body": ["engaging", "guided"]
  },

  "email_cold_outreach": {
    "email_cold_outreach_subject_line": ["standard"],
    "email_cold_outreach_body": ["standard", "personalized", "aida", "pas", "bab", "guided"]
  },

  "sms": {
    "sms": ["sms_160", "sms_320", "sms_480"]
  },

  "shopify_landing_page": {
    "landing_page_copy": ["paragraph", "pas", "engaging", "creative"],
    "landing_page_headline": [],
    "landing_page_call_to_action": []
  },
  "shopify_product": {
    "landing_page_product_name": ["creative"],
    "landing_page_product_description": ["paragraph", "list", "pas", "rewrite", "personalized"]
  },

  "shopify_products_description": {
    "landing_page_product_description": ["paragraph", "list", "pas", "rewrite", "personalized"]
  },

  "blog_post": {
    "blog_post_outline": [],
    "blog_post_intro_paragraph": ["standard"],
    "blog_post_title": ["standard"]
  },
  "canvas": {
    "canvas_aida": ["default"],
    "canvas_pas": ["default"],
    "canvas_bab": ["default"],
    "canvas_feature_to_benefits_practical": ["default"],
    "canvas_feature_to_benefits_emotional": ["emotional_benefits"],
    "canvas_perfect_headline": ["engaging"],
    "canvas_persuasive_bullet_point": ["default"],
    "canvas_value_proposition": ["default"],
    "canvas_product_description_paragraph": ["paragraph"],
    "canvas_product_description_list": ["list"],
    "canvas_product_description_relaxed": ["relaxed"],
    "canvas_blog_ideas": ["default"],
    "canvas_video_ideas": ["default"],
    "canvas_content_improver": ["default"],
    "canvas_eli5": ["default"],
    "canvas_sentence_expander": ["default"],
    "canvas_facebook_ad": ["creative"],
    "canvas_google_ad": ["creative"],
    "canvas_landing_page_builder": ["standard"],
    "canvas_landing_page_seo": ["creative"],
    "canvas_instagram_social": ["creative"],
    "canvas_facebook_social": ["creative"],
    "canvas_twitter_social": ["creative"],
    "canvas_linkedin_social": ["creative"],
    "canvas_youtube_social": ["creative"],
    "canvas_pinterest_pin_social": ["default"],
    "canvas_cold_email": ["standard"],
    "canvas_promotional_email": ["engaging"],
    "canvas_email_subject_line": ["standard"],
    "canvas_amazon_product_description": ["default"],
    "canvas_amazon_feature_list": ["default"],
    "canvas_walmart_product_description": ["default"],
    "canvas_walmart_feature_list": ["default"],
    "canvas_twitter_ad": ["default"],
    "canvas_linkedin_text_ad": ["default"],
    "canvas_pinterest_ad": ["default"],
    "canvas_sms": ["sms_160"],
    "canvas_freestyle": ["default"]
  }
}
